<template>
  <!--专题详情  -->
  <div class="topicDetail">
    <div class="detail_box">
      <el-card>
        <el-row>
          <el-button
            type="primary"
            @click="addOption"
            v-if="menuPerm('vote:insert')"
            :disabled="tabOpen && allOpen"
            >添加选项</el-button
          >
        </el-row>
        <el-table
          :data="optionList"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto; margin-top: 20px"
          tooltip-effect="light"
        >
          <el-table-column
            prop="projectName"
            label="标题"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="projectUrl"
            label="封面图"
            width="200px"
            height="200px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="vote_img">
                <img :src="row.projectUrl" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="projectIntroduce"
            label="介绍"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="ticketCount"
            label="投票次数"
            align="center"
          ></el-table-column>
          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="200px"
          >
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                @click="voteChange(row)"
                :disabled="tabOpen && allOpen"
                v-if="menuPerm('vote:update')"
                >修改</el-button
              >
              <el-button
                type="primary"
                @click="deleteOption(row)"
                v-if="menuPerm('vote:delete')"
                :disabled="tabOpen && allOpen"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>

    <!-- 添加选项 -->
    <a-modal
      title="添加选项"
      :visible="typeOpen"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
      :footer="null"
    >
      <el-form
        :model="optionAdd"
        label-position="left"
        label-width="80px"
        ref="ruleForm"
        style="marginleft: -70px"
      >
        <el-row>
          <el-form-item label="选项名字" prop="typeName">
            <el-input
              placeholder="请输入内容"
              v-model="optionAdd.projectName"
              clearable
            />
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="封面图(290*290)"
              prop="projectUrl"
              ref="projectUrl"
            >
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="TopicSuccess"
              >
                <img
                  v-if="$store.state.optionImg"
                  :src="$store.state.optionImg"
                  class="avatar"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="选项介绍" prop="projectIntroduce">
              <el-input
                placeholder="请输入内容"
                v-model="optionAdd.projectIntroduce"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitOption"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </a-modal>
    <!-- 修改选项 -->
    <a-modal
      title="修改选项"
      :visible="changeOpen"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
      :footer="null"
    >
      <el-form
        :model="changeOption"
        label-position="left"
        label-width="80px"
        ref="ruleForm"
        style="marginleft: -70px"
      >
        <el-row>
          <el-form-item label="选项名字" prop="typeName">
            <el-input
              placeholder="请输入内容"
              v-model="changeOption.projectName"
              clearable
            />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="投票次数" prop="ticketCount">
            <el-input
              type="number"
              placeholder="请输入内容"
              v-model="changeOption.ticketCount"
              clearable
            />
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="封面图" prop="projectUrl" ref="projectUrl">
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="changeSuccess"
              >
                <img
                  v-if="changeOption.projectUrl"
                  :src="changeOption.projectUrl"
                  class="avatar"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="活动介绍" prop="projectIntroduce">
              <el-input
                placeholder="请输入内容"
                v-model="changeOption.projectIntroduce"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="changeVoteOption"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </a-modal>
    <!-- 删除弹框 -->
    <a-modal v-model="visible" on-ok="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >
          确定
        </a-button>
      </template>
      <p>确定删除吗?</p>
    </a-modal>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.optionAdd.projectUrl == "") {
        callback(new Error("图片不能为空"));
      } else {
        callback();
      }
    };
    return {
       loading: false,
      loadUpt: false, //加载
      typeOpen: false,
      changeOpen: false,
      visible: false, //删除提示框
      tabOpen: false, //tab禁用框
      allOpen: true, //没有限制
      deleteOptionId: "", //删除选项的id
      optionList: [],
      //修改选项参数
      changeOption: {
        voteId: "",
        projectName: "", // 选项名字
        projectUrl: "", //选项的图片
        projectIntroduce: "", //选项的介绍
      },
      //添加选项
      optionAdd: {
        voteId: "",
        projectName: "", // 选项名字
        projectUrl: "", //选项的图片
        projectIntroduce: "", //选项的介绍
      },
      //校验
      addRules: {
        projectName: [
          { required: true, message: "标题不能为空", trigger: "blur" },
        ],
        projectUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
        projectIntroduce: [
          { required: true, message: "标题不能为空", trigger: "blur" },
        ],
      },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
    };
  },
  components: {},
  computed: {},
  props: ["Detaildata"],
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    // 上传图片
    TopicSuccess(file) {
      this.optionAdd.projectUrl = file.entity;
      this.$store.commit("voteOptionImg", file.entity);
    },
    // 修改选项的上传图片
    changeSuccess(file) {
      this.changeOption.projectUrl = file.entity;
    },
    // 修改选项
    voteChange(obj) {
      this.changeOption = obj;
      this.changeOpen = true;
    },
    // 修改保存
    changeVoteOption() {
      this.postAxios("/vote/update/option", {
        id: this.changeOption.id,
        projectName: this.changeOption.projectName,
        projectUrl: this.changeOption.projectUrl,
        projectIntroduce: this.changeOption.projectIntroduce,
        ticketCount: this.changeOption.ticketCount,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.changeOpen = false;
        } else if (res.success == false && res.statusCode == 401) {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 删除取消弹框
    handleCancel() {
      this.visible = false;
    },
    // 删除选项
    deleteOption(obj) {
      this.visible = true;
      this.deleteOptionId = obj;
    },
    // 确定删除
    handleOk() {
      this.visible = false;
      this.getAxios("/vote/delete/option", {
        id: this.deleteOptionId.id,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else if (res.success == false && res.statusCode == 401) {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 弹框取消
    handleCancel() {
      this.typeOpen = false;
      this.changeOpen = false;
      this.$store.state.optionImg = "";
      this.optionAdd = {};
    },
    // 添加选项
    addOption() {
      this.typeOpen = true;
      this.$store.state.optionImg = "";
    },
    // 保存
    submitOption() {
      this.postAxios("/vote/add/option", {
        voteId: this.$store.state.voteId, //投票活动的 id
        projectName: this.optionAdd.projectName, // 选项名字
        projectUrl: this.optionAdd.projectUrl, //选项的图片
        projectIntroduce: this.optionAdd.projectIntroduce, //选项的介绍
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
          this.typeOpen = false;
          this.optionAdd = {};
          this.$store.state.optionImg = "";
        } else if (res.success == false && res.statusCode == 401) {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取指定投票的所有选项
    getList() {
      this.getAxios("/vote/list/option", {
        id: this.$store.state.voteId,
      }).then((res) => {
        if (res.success) {
          this.optionList = res.content;
        } else if (res.success == false && res.statusCode == 401) {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 权限按钮判断
    isPermission() {
      if (
        this.Detaildata.examineStatus == 2 ||
        this.Detaildata.examineStatus == 4
      ) {
        // 没限制
        this.tabOpen = false; //no
      } else if (
        (this.Detaildata.examineStatus == 1 ||
          this.Detaildata.examineStatus == 3) &&
        this.allOpen
      ) {
        this.tabOpen = true; //tab禁用
      }
    },
  },
  created() {
    this.optionAdd.voteId = this.Detaildata.id;
    this.getList();
    this.isPermission();
  },
  mounted() {
    if (this.menuPerm("vote:update_edit") == true) {
      this.allOpen = false;
      this.tabOpen = false;
    }
  },
  watch: {
    Detaildata(newVal, oldVal) {
      this.optionAdd.voteId = newVal.id;
      this.getList();
      this.isPermission();
    },
  },
};
</script>
<style scoped>
.avatar-uploader {
  width: 200px;
  height: 200px;
  line-height: 200px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  border: 2px dashed #eee;
}
.el-upload img {
  width: 100%;
}
.vote_img img {
  width: 150px;
}
</style>